// extracted by mini-css-extract-plugin
export var deleteModal = "_j2-0";